import { Link } from "react-router-dom"
import PersonBadge from "./PersonBadge"

export default function ChapereeSummary({
    person,
    mainCard = false,
    mode = "full",
}) {
    const analysisPath = `/analysis/${person.slug}`

    return (
        <div className="d-flex">
            <div className="card-body flex-grow-1">
                <h3 className="card-title">
                    {person?.full_name || person.username}
                </h3>
                <h6>{person.entity_name ? `(${person.entity_name})` : ""}</h6>

                <Link
                    to={analysisPath}
                    className="d-inline-block"
                    title="Analysis"
                >
                    <PersonBadge person={person} mode={mode} />
                </Link>
                <Link className="dropdown-item " to={analysisPath}>
                    <button
                        className={`btn ${
                            mainCard
                                ? "btn-sm btn-danger"
                                : "btn-sm btn-outline-secondary"
                        } mt-1`}
                    >
                        Analysis
                    </button>
                </Link>
            </div>
        </div>
    )
}
